const PriceMovementType = {
  Initial: "initial",
  Discount: "discount",
  Account: "account",
  National: "national",
  ChangeRefS: "change-refs"
};

export default PriceMovementType;
